module.exports = __webpack_public_path__ + "static/media/add_icon.570919c6.svg";